/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  TextField,
  // InputAdornment,
  // SvgIcon,
  makeStyles,
  Modal,
  IconButton,
  // MenuItem,
  Grid,
  Typography,
  CircularProgress
} from '@material-ui/core';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Upload, X } from 'react-feather';
import { Delete } from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  MuiPickersUtilsProvider,
  // KeyboardTimePicker,
  DateTimePicker
  // KeyboardDateTimePicker
  // KeyboardDatePicker
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import firebase from 'firebase/app';
import md5 from 'md5';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  modal: {
    position: 'absolute',
    width: 600,
    maxWidth: '100%',
    maxHeight: '80%',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  imageButton: {
    textTransform: 'none',
    borderStyle: 'solid',
    display: 'block',
    borderRadius: 4,
    width: '100%',
    height: 80,
    textAlign: 'center',
    backgroundColor: '#f2f2f2'
  }
}));

function ImageInput(props) {
  const classes = useStyles();
  const { errorMessage, field, form, onBlur } = props;
  const { setFieldError } = form;
  const { name } = field;
  const fileUpload = React.createRef();
  const [images, setImages] = useState();
  const [error, seterror] = useState(errorMessage);

  React.useEffect(() => {
    seterror(errorMessage);
  }, [errorMessage]);

  async function handleImageChange(e) {
    e.preventDefault();

    const { files } = e.target;
    console.log('WAIT FOR THIS', files);
    if (files?.length > 0) {
      // eslint-disable-next-line array-callback-return
      const fuck = [...e.target.files].map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve({ file, imagePreviewUrl: reader.result });
          };
          reader.readAsDataURL(file);
        });
      });
      const mongo = await Promise.all(fuck);
      setImages(mongo);
      console.log(mongo);
      props.setFieldValue(props.field.name, mongo);
    } else {
      setFieldError(props.field.name, 'File Error');
    }
  }

  return (
    <>
      {images
        ? images.map((image) => (
            // eslint-disable-next-line react/jsx-indent
            <Box mb={2} mt={2} key={image.imagePreviewUrl}>
              <Card className={classes.root} variant="outlined">
                <Grid container>
                  <Grid item xs={3}>
                    <div
                      style={{
                        width: '100%',
                        paddingTop: '100%',
                        position: 'relative',
                        background: '#f2f2f2'
                      }}
                    >
                      <img
                        key={image.imagePreviewUrl}
                        src={image.imagePreviewUrl}
                        alt=""
                        style={{
                          objectFit: 'contain',
                          position: 'absolute',
                          top: 0,
                          width: '100%',
                          height: '100%'
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={9}>
                    <Box p={1}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        <Typography component="strong">Name:</Typography>{' '}
                        {image.file.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        <Typography component="strong">Size:</Typography>{' '}
                        {image.file.size} bytes
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        <Typography component="strong">Type:</Typography>{' '}
                        {image.file.type}
                      </Typography>
                    </Box>
                    <CardActions>
                      <IconButton
                        size="small"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => {
                          const updatedImages = images.filter(
                            (item) => item.file.name !== image.file.name
                          );
                          if (images.length === 1) {
                            props.setFieldValue(props.field.name, []);
                          }
                          setImages(updatedImages);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </CardActions>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          ))
        : null}
      <Button
        id={name}
        name={name}
        onClick={() => {
          fileUpload.current.value = null;
          fileUpload.current.click();
        }}
        className={classes.imageButton}
        // touched
        onBlur={onBlur}
        style={{
          borderColor: error ? 'red' : 'transparent',
          borderWidth: error ? 1 : 0
        }}
      >
        <Typography variant="button" display="block" component="p">
          <Upload />
        </Typography>

        <Typography variant="body1" component="p" display="block">
          Upload photos you want to attach
        </Typography>

        <input
          // file
          // required
          multiple
          hidden
          style={{
            overflow: 'hidden',
            paddingTop: '100%',
            width: 100,
            height: 100,
            borderRadius: 50,
            borderWidth: 0,
            outline: 0
          }}
          ref={fileUpload}
          label="Upload profile photo"
          // fullWidth
          onChange={handleImageChange}
          // className={classes.hidden}
          // variant="outlined"
          // id={name}
          // name={name}
          type="file"
        />
      </Button>
      {error ? (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      ) : null}
    </>
  );
}

ImageInput.propTypes = {
  errorMessage: PropTypes.string,
  setFieldValue: PropTypes.func,
  onBlur: PropTypes.func,
  field: PropTypes.object,
  form: PropTypes.object
  // touched: PropTypes.bool
};

const Toolbar = ({ className, pages, ...rest }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [dateTimePickerOpen, setDateTimePickerOpen] = useState(false);
  const [formValidateError, setformValidateError] = useState();
  const [loading, setLoading] = useState(false);

  async function uploadImageStorage(id, files) {
    const promises = files.map(async (item, index) => {
      const ext = item.file.name.split('.').pop();

      const uploadRef = `posts/${`${id}_${index}.${ext?.toLocaleLowerCase()}`}`;

      return firebase
        .storage()
        .ref(uploadRef)
        .put(item.file)
        .then(() => {
          console.log('Item upload succes no: ', index);
        })
        .catch((e) => {
          setLoading(false);
          console.log('Storage upload Error:', e);
        })
        .then(() => firebase.storage().ref(uploadRef).getDownloadURL())
        .then((res) => res);
    });

    const results = await Promise.all(promises);

    return results;
  }

  async function getURLPreview(text) {
    return firebase
      .functions()
      .httpsCallable('getURLPreview-GetURLPreview')(text)
      .then((res) => res.data)
      .catch((e) => console.log(e));
  }

  async function createPost(values) {
    const { author, files, text, publishDate } = values;
    setLoading(true);
    const hashedTimeStamp = md5(new Date().toISOString());
    const docId = `${author.id}_${hashedTimeStamp}`;
    let downloadURLs = [];

    const _data = {
      text,
      createDate:
        publishDate || firebase.firestore.FieldValue.serverTimestamp(),
      countryCode: author.countryCode,
      likeCount: 0,
      commentCount: 0,
      createdBy: {
        id: author.id,
        title: author.title,
        photoURL: author.photoURL
      },
      byAdmin: true,
      status: 'active'
    };

    if (files && files.length > 0) {
      downloadURLs = await uploadImageStorage(docId, files);
    }

    if (downloadURLs?.length > 0) _data.picture = downloadURLs;

    if (_data.text) {
      const preview = await getURLPreview(_data.text);
      if (preview) {
        _data.previewURL = preview;
      }
    }

    return firebase.firestore().doc(`posts/${docId}`).set(_data);
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function countryToFlag(isoCode) {
    return typeof String.fromCodePoint !== 'undefined'
      ? isoCode
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(char.charCodeAt(0) + 127397)
          )
      : isoCode;
  }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box display="flex" justifyContent="flex-end">
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleOpen()}
        >
          Add Post
        </Button>
      </Box>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Box maxWidth={300}>
              <Autocomplete
                id="page"
                fullWidth
                options={
                  pages || [{ countryCode: 'TR', title: 'Veganzone Turkey' }]
                }
                classes={{
                  option: classes.option
                }}
                onChange={() => {
                  // setFieldValue('country', value);
                }}
                autoHighlight
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <>
                    <span style={{ marginRight: 4 }}>
                      {countryToFlag(option.countryCode)}
                    </span>
                    {option.title} ({option.countryCode})
                  </>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Filter For Author"
                    variant="outlined"
                    // error={Boolean(touched.country && errors.country)}
                    // helperText={touched.country && errors.country}
                    // onBlur={handleBlur}
                    inputProps={{
                      ...params.inputProps
                      // autoComplete: 'new-password' // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Modal
        disableBackdropClick={!!loading}
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modal}>
          {formValidateError ? (
            <Box mb={2}>
              <Alert
                severity="error"
                onClose={() => setformValidateError(null)}
                className={classes.alert}
              >
                <AlertTitle>Error</AlertTitle>
                {formValidateError}
              </Alert>
            </Box>
          ) : null}
          <Formik
            initialValues={{
              files: [],
              text: '',
              author: '',
              publishDate: undefined
            }}
            validationSchema={Yup.object().shape(
              {
                files: Yup.array().when('text', {
                  is: (text) => !text || text.length === 0,
                  then: Yup.array()
                    .min(
                      1,
                      'At least a photo is required if you leave text area empty'
                    )
                    .required(
                      'At least a photo is required if you leave text area empty'
                    ),
                  otherwise: Yup.array().optional()
                }),
                text: Yup.string().when('files', {
                  is: (files) => !files || files.length === 0,
                  then: Yup.string().required(
                    'Text is required if you are not attach any photos'
                  ),
                  otherwise: Yup.string().optional()
                }),
                author: Yup.object().required('You must select an author'),
                publishDate: Yup.date().optional()
              },
              [['files', 'text']]
            )}
            onSubmit={async (values) => {
              await createPost(values)
                .then(() => {
                  setLoading(false);
                  setOpen(false);
                })
                .catch((e) => {
                  setformValidateError(
                    `An error happend during creating page. Code: ${e}`
                  );
                  setLoading(false);
                });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <Autocomplete
                    id="author"
                    name="author"
                    fullWidth
                    options={pages || [{}]}
                    classes={{
                      option: classes.option
                    }}
                    onChange={(e, value) => {
                      setFieldValue('author', value);
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.title}
                    renderOption={(option) => (
                      <>
                        <span style={{ marginRight: 4 }}>
                          {countryToFlag(option.countryCode)}
                        </span>
                        {option.title} ({option.countryCode})
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        label="Choose an author"
                        variant="outlined"
                        error={Boolean(touched.author && errors.author)}
                        helperText={touched.author && errors.author}
                        onBlur={handleBlur}
                        inputProps={{
                          ...params.inputProps
                          // autoComplete: 'new-password' // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    required
                    multiline
                    error={Boolean(touched.text && errors.text)}
                    fullWidth
                    helperText={touched.text && errors.text}
                    label="Text"
                    margin="normal"
                    rows={4}
                    rowsMax={6}
                    name="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    id="text"
                    type="text"
                    value={values.text}
                    variant="outlined"
                  />
                </Box>

                <Box mb={2}>
                  <Field
                    // id="files"
                    name="files"
                    component={ImageInput}
                    title="Select a file"
                    setFieldValue={setFieldValue}
                    errorMessage={errors.files ? errors.files : undefined}
                    touched={touched.files}
                    style={{ display: 'flex' }}
                    onBlur={handleBlur}
                  />
                </Box>

                <Box
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <>
                    {!values.publishDate ? (
                      <Button
                        onClick={() => {
                          // setScheduleDate(new Date());
                          setFieldValue('publishDate', new Date());
                          setDateTimePickerOpen(true);
                        }}
                        disabled={isSubmitting}
                        // fullWidth
                        size="large"
                        type="button"
                        variant="contained"
                      >
                        Shedule for later
                      </Button>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <DateTimePicker
                            open={dateTimePickerOpen}
                            onOpen={() => setDateTimePickerOpen(true)}
                            onClose={() => setDateTimePickerOpen(false)}
                            label="Schedule date & time: UTC"
                            inputVariant="outlined"
                            id="dateTimePickerRef"
                            minDate={moment(new Date()).utc()}
                            value={moment(values.publishDate).utc()}
                            onChange={(value) => {
                              setFieldValue(
                                'publishDate',
                                moment(value).utc().toDate()
                              );
                            }}
                            style={{ width: 200 }}
                          />
                        </MuiPickersUtilsProvider>
                        <Button
                          onClick={() => {
                            setFieldValue('publishDate', undefined);
                          }}
                          size="small"
                          // type="button"
                          style={{
                            marginLeft: 5,
                            minWidth: 10,
                            overflow: 'hidden'
                          }}
                          variant="contained"
                        >
                          <X size={20} />
                        </Button>
                      </div>
                    )}
                  </>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    // fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    {isSubmitting ? <CircularProgress /> : 'POST'}
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </div>
      </Modal>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array
};

export default Toolbar;
